import React, { useState, useContext } from 'react'
import SmsOptIn from '@pcln/sms-opt-in'
import { Container, Card, Link } from 'pcln-design-system'
import useGetDisclaimer from '@/hooks/smsOptIn/useGetDisclaimer'
import { handleSubmit, SmsPhone } from '@/hooks/smsOptIn/useSubmitSmsOptIn'
import BootstrapDataContext from '@/context/BootstrapDataContext'

const imageUrl =
  'https://s1.pclncdn.com/design-assets/brand-assets/business-man-in-car.jpg?opto&dpr=2&orient=2&width=256&crop=3:2,smart'
const altImageText = 'business man in car'
const smallImageUrl =
  'https://s1.pclncdn.com/design-assets/brand-assets/business-man-in-car.jpg?opto&dpr=2&orient=2&width=256&crop=2:3,smart'
const smallImageAltText = 'business man in car'
const headline = 'NEW: Get savings texted to you directly!'
const subheadline = `Provide your phone number and we'll send you special deals and promotions via SMS.`

const baseParamsMobile = {
  disclaimerBaseParam: {
    placement: 'HOMEPAGE',
    appCode: 'MOBILEWEB',
    classification: 'PROMOTIONAL',
    PLFCode: 'PCLN'
  }
}
const baseParamsDesktop = {
  disclaimerBaseParam: {
    placement: 'HOMEPAGE',
    appCode: 'DESKTOP',
    classification: 'PROMOTIONAL',
    PLFCode: 'PCLN'
  }
}
export default function SmsOptInComponent() {
  const {
    customer: { emailAddress = '' },
    isMobile,
    webstats: { clientGUID }
  } = useContext(BootstrapDataContext)
  const baseParams = isMobile ? baseParamsMobile : baseParamsDesktop
  const disclaimers = useGetDisclaimer(baseParams)
  const [signUpState, setSignUpState] = useState('NOT_SIGNED_UP')
  const [signUpSubmitFailureMessage, setSignUpSubmitFailureMessage] = useState<
    string | undefined
  >('')

  const validDisclaimer = disclaimers?.find(
    disclaimer => !disclaimer.optinStatus
  )

  const disclaimerText = validDisclaimer?.disclaimerText?.reduce(
    (previousValue, currentValue) => previousValue + currentValue.text,
    ''
  )

  const disclaimerTextNode = (
    <>
      {validDisclaimer?.disclaimerText?.map(({ text, url }, index) => {
        const uniqueKey = isMobile ? `m${index}` : `d${index}`
        return url ? (
          <Link href={url} target="blank" key={uniqueKey}>
            {text}
          </Link>
        ) : (
          <span key={uniqueKey}>{text}</span>
        )
      })}
    </>
  )

  return (
    <Container maxWidth={1280}>
      <Card
        borderRadius="xl"
        mx={[0, null, null, null, 4]}
        mt={[0, null, null, null, '40px']}
        mb={[3, null, null, null, 0]}
        p={4}
      >
        <SmsOptIn
          headline={headline}
          subheadline={subheadline}
          imageUrl={imageUrl}
          smallImageUrl={smallImageUrl}
          buttonSize="large"
          textInputRadius="lg"
          signUpState={signUpState}
          imageWidth={1 / 3}
          formWidth={2 / 3}
          disclaimerTextNode={disclaimerTextNode}
          handleFormSubmit={(formData: SmsPhone) =>
            handleSubmit({
              emailAddress,
              formData,
              disclaimerText: disclaimerText || '',
              baseParams,
              setSignUpState,
              setSignUpSubmitFailureMessage,
              clientGUID
            })
          }
          phoneInputErrorMessage={signUpSubmitFailureMessage}
          altImageText={altImageText}
          smallImageAltText={smallImageAltText}
        />
      </Card>
    </Container>
  )
}
